import { useEffect, useState } from "react";

const BASE_URL = "https://be-ofertas.utpl.edu.ec";

const DataFetcherPosgrados = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 Obtener UNA imagen
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url || null;
  };

  // 🔥 Obtener MUCHAS imágenes (por si el campo es múltiple)
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node.relationships?.[fieldName]?.data;
    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id,
        );

        const fileId = media?.relationships?.field_media_image?.data?.id;

        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId,
        );

        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const json = await response.json();

        const node = json?.data;
        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // 🔥 Imágenes
        const imagePortada = getImageUrl(
          node,
          included,
          "field_imagen_portada",
        );

        const imagePerfil = getImageUrl(
          node,
          included,
          "field_imagen_perfil_de_egreso",
        );

        const imageRequisitos = getImageUrl(
          node,
          included,
          "field_imagen_requisitos",
        );

        // (opcional) si algún día es múltiple
        const galeria = getImageUrls(node, included, "field_galeria");

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          titulo_recibir: atributos.field_titulo,
          precio: atributos.field_precio,
          duracion: atributos.field_duracion,
          modalidad: atributos.field_modalidad,
          campo: atributos.field_campo_amplio,
          resolucion: atributos.field_resolucion?.processed,
          inicio: atributos.field_inicio_clases,
          ingreso: atributos.field_perfil_de_ingreso?.processed,
          egreso: atributos.field_perfil_de_egreso?.processed,
          requisitos: atributos.field_requisitos_de_postulacion?.processed,
          malla: atributos.field_malla_curricular?.processed,
          info1: atributos.field_atributo_1?.processed,
          info2: atributos.field_atributo_2?.processed,
          info3: atributos.field_atributo_3?.processed,

          field_texto_portada: atributos.field_texto_portada,
          field_publicado: atributos.field_publicado,
          field_enlace_postulacion: atributos.field_enlace_postulacion,

          // ✅ imágenes listas para usar
          imagen_portada: imagePortada ? BASE_URL + imagePortada : "",
          imagen_perfil: imagePerfil ? BASE_URL + imagePerfil : "",
          imagen_requisitos: imageRequisitos ? BASE_URL + imageRequisitos : "",

          // opcional
          galeria,
        };

        setData(cleanData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcherPosgrados;
